export interface GeoTheme {
  background: string;
  regionFill: string;
  regionStroke: string;
  hoverFill: string;
  selectedFill: string;
  correctFill: string;
  incorrectFill: string;
  strokeWidth: number;
  labelColor: string;
  labelFont: string;
  labelZoomThreshold: number;
}

export const DEFAULT_GEO_THEME: GeoTheme = {
  background: "#f5f2ea",
  regionFill: "#d6d0c5",
  regionStroke: "#7f776b",
  hoverFill: "rgba(80, 120, 200, 0.35)",
  selectedFill: "rgba(48, 163, 76, 0.4)",
  correctFill: "rgba(48, 163, 76, 0.5)",
  incorrectFill: "rgba(205, 61, 61, 0.45)",
  strokeWidth: 1,
  labelColor: "#3c3831",
  labelFont: "600 12px 'Source Serif 4', serif",
  labelZoomThreshold: 1.6,
};
